import { useRef, useState } from "react";
import VehicleCard from "./VehicleCard";
import RequestQuoteForm from "./RequestQuoteForm";
import { CircularProgress } from "@mui/material";
import { useVehicles } from "../context/VehiclesContext";

function Hero() {
  const { vehicles } = useVehicles();
  const fleetRef = useRef(null);
  const [focusedId, setFocusedId] = useState(null);

  const bookBtn = () => {
    document
      .querySelector("#booking-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  const scrollFleet = (direction) => {
    const fleetEl = fleetRef.current;
    if (!fleetEl) return;

    // Exit focus first so the grid stays scrollable (overflow-x: auto).
    setFocusedId(null);

    fleetEl.scrollBy({
      left: direction * fleetEl.clientWidth,
      behavior: "smooth",
    });
  };

  const isFocused = Boolean(focusedId);

  return (
    <section className='hero-section-bg-2'>
      <div
        className={`hero-viewport${isFocused ? " hero-viewport--focus" : ""}`}
      >
        <div className='container hero-viewport__content'>
          <div className='hero-text-2'>
            <h1>Car, Van &amp; Ute Rental in Melbourne</h1>
            <div>
              <div className='category-main-2'>
                <div className='category-2'>CARS</div>
                <div className='category-2'>SUVS</div>
                <div className='category-2'>UTES</div>
                <div className='category-2'>VANS</div>
              </div>
            </div>
          </div>

          <div className='hero-btn-flex'>
            <button onClick={bookBtn} className='reserve-now-btn'>
              <span> Request a Quote </span>
            </button>

            <a href='tel:0400920512' className='reserve-now-btn'>
              <span>Call Us</span>
            </a>
          </div>
        </div>

        <div className='VehicleCard-slider-2'>
          {vehicles.length === 0 ? (
            <div className='vehicle-fleet-loading'>
              <CircularProgress />
            </div>
          ) : (
            <div
              className={`vehicle-fleet-wrapper${
                isFocused ? " vehicle-fleet-wrapper--focus" : ""
              }`}
              onMouseLeave={() => setFocusedId(null)}
              onBlur={(e) => {
                if (!e.currentTarget.contains(e.relatedTarget)) {
                  setFocusedId(null);
                }
              }}
            >
              <button
                type='button'
                className='vehicle-fleet-nav vehicle-fleet-nav--prev'
                onMouseEnter={() => setFocusedId(null)}
                onClick={() => scrollFleet(-1)}
                aria-label='Previous vehicles'
              >
                <svg
                  className='vehicle-fleet-nav__icon'
                  viewBox='0 0 24 24'
                  aria-hidden='true'
                  focusable='false'
                >
                  <path
                    d='M15.5 4.5L8 12l7.5 7.5'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2.4'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
              <div className='vehicle-fleet-grid' ref={fleetRef}>
                {vehicles.map((vehicle, index) => (
                  <div
                    className={`vehicle-fleet-item${
                      focusedId === vehicle.id ? " is-focused" : ""
                    }`}
                    key={vehicle.id}
                    onMouseEnter={() => setFocusedId(vehicle.id)}
                    onFocus={() => setFocusedId(vehicle.id)}
                  >
                    <VehicleCard
                      imageUrl={vehicle.imageUrl}
                      vehicleName={vehicle.vehicleName}
                      category={vehicle.category}
                      doors={vehicle.doors}
                      seats={vehicle.seats}
                      transmission={vehicle.transmission}
                      perDayPrice={vehicle.perDayPrice}
                      priority={index < 3}
                    />
                  </div>
                ))}
              </div>
              <button
                type='button'
                className='vehicle-fleet-nav vehicle-fleet-nav--next'
                onMouseEnter={() => setFocusedId(null)}
                onClick={() => scrollFleet(1)}
                aria-label='Next vehicles'
              >
                <svg
                  className='vehicle-fleet-nav__icon'
                  viewBox='0 0 24 24'
                  aria-hidden='true'
                  focusable='false'
                >
                  <path
                    d='M8.5 4.5L16 12l-7.5 7.5'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2.4'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>

      <div id='booking-section' className='hero-quote-section'>
        <div className='container'>
          <div className='book-content'>
            <div className='book-content__box hero-quote-box'>
              <RequestQuoteForm idPrefix='hero' />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
